import { PLAN_TYPE_FR, PLAN_TYPE_HEALTH } from './plan';
import { IDropzoneValidator } from '../interfaces/fileUploaderContainer';
import { ICompanyPlan } from '../interfaces/plans';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../translations/manageCollaborators';
import { ManageCollaboratorsUploadSteps } from '../types/types';

export const MANAGE_COLLABORATORS_UPLOAD_COLLABORATORS_TITLE: Record<
  ManageCollaboratorsUploadSteps,
  { title: string; subtitle: string; title2?: string; subtitle2?: string }
> = {
  0: {
    title: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.generalTitle,
    subtitle: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.selectPlan.subtitle
  },
  1: {
    title: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.generalTitle,
    subtitle: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.selectUploadMethod.subtitle
  },
  2: {
    title: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.generalTitle,
    subtitle: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.manageEmails.subtitle,
    subtitle2: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.uploadByFile.subtitle
  },
  3: {
    title: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.generalTitle,
    subtitle: TRANSLATION_MANAGE_COLLABORATORS.hero.uploadCollaboratorsSection.checkout.subtitle
  }
};

export const MANAGE_COLLABORATORS_UPLOAD_TOTAL_STEPS = 5;

export const DEFAULT_COMPANY_PLAN_VALUE: ICompanyPlan = {
  addons: [],
  commercialPlanId: 0,
  countryCode: '',
  currency: '',
  description: '',
  id: 0,
  name: '',
  price: 0,
  supportDependents: false,
  isNewExperience: true,
  status: 'inactive',
  type: 'standard'
};

export const SUBSCRIPTION_FILE_UPLOADER_VALIDATORS: IDropzoneValidator = {
  maxFileCount: 1,
  maxFileSize: 6291456, // 6MB
  fileFormats: {
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
  }
};

export const INFORMATIVE_MODAL_ITEMS = [
  [
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.name,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.id,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.email
  ],
  [
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.birthDate,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.gender
  ]
];

export const INFORMATIVE_MODAL_ITEMS_FR = [
  [
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.name,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.id,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.email,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.hoursWorked
  ],
  [
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.birthDate,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.gender,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.salary,
    TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.items.zipCode
  ]
];

export const DEPENDENTS_INFORMATIVE_MODAL_ITEMS = [
  [
    TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.items.collaboratorId,
    TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.items.name,
    TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.items.gender
  ],
  [
    TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.items.relationship,
    TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.items.id,
    TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.items.birthday
  ]
];

export const LOCALE_COUNTRYS: { [key: string]: { country: string } } = {
  AR: { country: 'Argentina' },
  ES: { country: 'España' },
  EC: { country: 'Ecuador' },
  MX: { country: 'Mexico' },
  CO: { country: 'Colombia' },
  PE: { country: 'Peru' },
  BR: { country: 'Brazil' },
  CL: { country: 'Chile' },
  US: { country: 'USA' }
};

export const SKIP_LOAD_METHOD = [PLAN_TYPE_FR, PLAN_TYPE_HEALTH];

export const COLLABORATOR_ID_BY_COUNTRY = {
  CL: 'RUT',
  MX: 'RFC',
  ES: 'DNI/NIE'
};

export const DEPENDENTS_ID_BY_COUNTRY = {
  CL: 'RUT',
  MX: 'RFC/CURP',
  ES: 'DNI/NIE'
};

export const COUNTRIES_WITH_DEPENDENTS_DOC_TYPE = ['MX'];
